<template>
   <div>
      <nav class="nav nav-tabs nav-justified d-flex">
         <a
         v-for="step in this.steps"
         :key="step.id"
         @click="sendStep(step)"
         :class ="['nav-item nav-link flex-fill',
         (currentStep === step.id) ? activeClass : '',
         step.enabled ? '' : disabledClass,
         step.complete ? completeClass : '']"
         >
            <!-- For a future proofed design check if a function can be passed to determine the displayed output making it a better re-usable component -->
            <span>{{step.id}}. </span><span class="xs_text">{{step.title}}</span>
         </a>
      </nav>
   </div>
</template>

<script>
   import { mapGetters } from 'vuex'

   export default {
      props: {
         /*
         * steps must been an array of objects; each containing:
         * id (int), name (string), enabled (bool), complete (bool)
         *
         */
         steps:{
            type: Array,
            required: true,
         },
         // current step is the ID of the current step
         currentStep:{
            type: Number,
            required: true,
         },
      },
      data: function(){
         // each class for ease of change is a data element
         return {
            activeClass: 'active',
            disabledClass: 'disabled',
            completeClass: 'complete'
         }
      },
      methods: {
         //event handler when the tabs are clicked
         sendStep(data){
            this.$emit('goTo', data);
         },
      }
   }
</script>
